import axios from 'axios';
import { message } from 'antd';
import { axiosApi } from '../axios-api';

export async function fetchProjectById(projectId) {
  try {
    const { data } = await axiosApi.get(`/projects/${projectId}/`);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
      return;
    }
    throw new Error(error);
  }
}

export async function fetchProjectFeed(projectId, feedId) {
  try {
    const { data } = await axiosApi.get(`/projects/${projectId}/feeds/${feedId}/`);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
      return;
    }
    throw new Error(error);
  }
}

export async function fetchProjectRule(projectId, ruleId) {
  try {
    const { data } = await axiosApi.get(`/projects/${projectId}/rules/${ruleId}/`);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
      return;
    }
    throw new Error(error);
  }
}

export async function fetchProjectMapping(projectId, mappingId) {
  try {
    const { data } = await axiosApi.get(`/projects/${projectId}/mappings/${mappingId}/`);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
      return;
    }
    throw new Error(error);
  }
}

export async function fetchStaticFeedTypesJson() {
  try {
    const { data } = await axios.get(`/data/feed_types.json`);
    return data;
  } catch (error) {
    throw new Error(`[fetchFeedTypes] Error.\n${error.message}`);
  }
}

export async function fetchProjectDesign(projectId, designId) {
  try {
    const { data } = await axiosApi.get(`/projects/${projectId}/designs/${designId}/`);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
      return;
    }
    throw new Error(error);
  }
}

export async function fetchProjectDesignsList(projectId) {
  try {
    const { data } = await axiosApi.get(`/projects/${projectId}/designs/`);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
      return;
    }
    throw new Error(error);
  }
}

export async function deleteProjectDesignRequest(projectId, designId) {
  try {
    await axiosApi.delete(`/projects/${projectId}/designs/${designId}`);
    return true;
  } catch (error) {
    message.error(error.message);
    return false;
  }
}

export async function fetchOrganizationsRoles() {
  try {
    const { data } = await axiosApi.get('v2/accounts/organizations/roles/');
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
      return;
    }
    throw new Error(error);
  }
}

export async function fetchOrganizationRolesByOrganizationId(organizationId) {
  try {
    const { data } = await axiosApi.get(
      `v2/accounts/organizations/roles/?organization=${organizationId}`,
    );
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}

export async function fetchOrganizationsProjectsFiltered(organizationId) {
  const url = organizationId
    ? `v2/accounts/organizations/projects/?id__in=${organizationId}`
    : 'v2/accounts/organizations/projects/';
  try {
    const { data } = await axiosApi.get(url);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}

export async function fetchOrganizationProjectForUpdate(organizationId, projectId) {
  try {
    const { data } = await axiosApi.get(
      `v2/accounts/organizations/projects/?id__in=${organizationId}&projects_in=${projectId}`,
    );
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: error.message,
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}

export async function postOrganizationRequest(requestBody) {
  try {
    const { data } = await axiosApi.post('v2/accounts/organizations/', requestBody);
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: `Something went wrong! ${error.message}`,
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}

export async function patchOrganizationNameRequest(id, name) {
  try {
    const { data } = await axiosApi.patch(`v2/accounts/organizations/${id}/`, { name });
    return data;
  } catch (error) {
    if (error.isAxiosError) {
      message.warning({
        content: `Something went wrong! ${error.message}`,
        duration: 3,
      });
    } else {
      throw new Error(error);
    }
  }
}


export async function fetchFeed({
  feedId,
  pageNum,
  productId,
  searchField,
  searchValue,
}) {
  const params = {
    feed_id: feedId,
    page_num: pageNum,
  };
  if (productId != null && productId !== '') {
    params.product_id = productId;
  }
  if (searchField && searchValue) {
    params.search_field = searchField;
    params.search_value = searchValue;
  }
  const { data } = await axiosApi.get('/feed/', { params });
  return data;
}

export function hasFeedSearchFilter(query) {
  if (!query) return false;
  if (query.productId) return true;
  return Boolean(query.searchField && query.searchValue);
}

